import { NucleoStack } from '@lyearn/icons';
import { AvatarOrInitials } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { IconSettings } from '@/components/IconSettings';
import { IconSettings as IconSettingsType } from '@/types/schema';

interface ProjectIconProps {
  name: string;
  iconSettings?: IconSettingsType | null;
  size: number;
  className?: string;
  fallbackIcon?: typeof NucleoStack;
}
export default function ProjectIcon(props: ProjectIconProps) {
  const { name, iconSettings, size, className } = props;

  if (iconSettings) {
    return (
      <IconSettings
        Icon={NucleoStack}
        className={className}
        iconSettings={iconSettings}
        size={size}
      />
    );
  }

  return <AvatarOrInitials className={cn(className)} name={name} size={size} />;
}
